import { isK3000domain } from './app/core/common';

export function appendFavicon() {
    const alineaIconPath = 'favicon.ico';
    const k3000IconPath = '/assets/images/sensotec-favicon.ico';
    const link = document.createElement('link');
    link.type = 'image/x-icon';
    link.rel = 'shortcut icon';
    if (isK3000domain()) {
        link.href = k3000IconPath;
    } else {
        link.href = alineaIconPath;
    }
    document.getElementsByTagName('head')[0].appendChild(link);
}

appendFavicon();
